'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import TouchMixin from './mixins/touch'

var range = function range(num, min, max) {
  return Math.min(Math.max(num, min), max);
};
var THRESHOLD = 0.15;
exports.default = {
  name: 'midea-swipe-cell',
  // mixins: [TouchMixin],
  props: {
    onClose: Function,
    height: {
      type: Number,
      default: 96
    },
    disabled: {
      type: Boolean,
      default: false
    },
    leftWidth: {
      type: Number,
      default: 0
    },
    rightWidth: {
      type: Number,
      default: 0
    },
    leftBackground: {
      type: String,
      default: '#ff4444'
    },
    rightBackground: {
      type: String,
      default: '#ff4444'
    },
    color: {
      type: String,
      default: '#ffffff'
    }
  },

  data: function data() {
    return {
      offset: 0,
      dragging: false
    };
  },


  computed: {
    wrapperStyle: function wrapperStyle() {
      var offset = this.offset,
          dragging = this.dragging,
          leftWidth = this.leftWidth,
          rightWidth = this.rightWidth;

      var style = {
        width: 750 + leftWidth + rightWidth + 'px',
        transform: 'translateX(' + (offset - leftWidth) + 'px)',
        transitionProperty: 'transform',
        transitionDuration: dragging ? '0' : '.6s',
        transitionTimingFunction: dragging ? 'none' : 'cubic-bezier(0.18, 0.89, 0.32, 1)'
      };
      return style;
    },
    leftStyle: function leftStyle() {
      var leftWidth = this.leftWidth,
          leftBackground = this.leftBackground,
          color = this.color,
          height = this.height;

      var style = {
        width: leftWidth + 'px',
        height: height + 'px',
        backgroundColor: leftBackground,
        color: color
      };
      return style;
    },
    rightStyle: function rightStyle() {
      var rightWidth = this.rightWidth,
          rightBackground = this.rightBackground,
          color = this.color,
          height = this.height;

      var style = {
        width: rightWidth + 'px',
        height: height + 'px',
        backgroundColor: rightBackground,
        color: color
      };
      return style;
    }
  },

  methods: {
    onClick: function onClick() {
      var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'outside';

      this.$emit('click', position);

      if (!this.offset) {
        return;
      }

      if (this.onClose) {
        this.onClose(position, this);
      } else {
        this.swipeMove(0);
      }
    },
    swipeMove: function swipeMove() {
      var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.offset = range(offset, -this.rightWidth, this.leftWidth);
      if (this.offset) {
        this.swiping = true;
      } else {
        this.opened = false;
      }
    },
    resetSwipeStatus: function resetSwipeStatus() {
      this.swiping = false;
      this.opened = true;
    },
    open: function open(position) {
      var offset = position === 'left' ? this.leftWidth : -this.rightWidth;
      this.swipeMove(offset);
      this.resetSwipeStatus();
    },
    close: function close() {
      this.offset = 0;
    },
    swipeLeaveTransition: function swipeLeaveTransition(direction) {
      var offset = this.offset,
          leftWidth = this.leftWidth,
          rightWidth = this.rightWidth;

      var threshold = this.opened ? 1 - THRESHOLD : THRESHOLD;

      // right
      if (direction === 'right' && -offset > rightWidth * threshold && rightWidth > 0) {
        this.open('right');
        // left
      } else if (direction === 'left' && offset > leftWidth * threshold && leftWidth > 0) {
        this.open('left');
        // reset
      } else {
        this.swipeMove(0);
      }
    },
    startDrag: function startDrag(event) {
      if (this.disabled) {
        return;
      }
      this.dragging = true;
      this.startOffset = this.offset;
      this.touchStart(event);
    },
    onDrag: function onDrag(event) {
      if (this.disabled) {
        return;
      }
      this.touchMove(event);
      if (this.direction === 'horizontal') {
        // event.preventDefault()
        this.swipeMove(this.deltaX + this.startOffset);
      }
    },
    endDrag: function endDrag(event) {
      if (this.disabled) {
        return;
      }
      this.dragging = false;

      if (this.swiping) {
        this.swipeLeaveTransition(this.offset > 0 ? 'left' : 'right');
      }
    },
    onTransitionend: function onTransitionend() {
      this.swiping = false;
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/swipe-cell/index.vue
// module id = 417
// module chunks = 0 1